import { observer } from "mobx-react-lite";
import { Fragment, useState, useRef, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Space,
  Steps,
  Row,
  Col,
  Upload,
  Image,
  UploadFile,
  UploadProps,
  GetProp,
  message,
  FormProps,
  Radio,
  DatePicker,
  FormInstance,
  QRCode,
  InputNumber,
  TreeSelect
} from "antd";
import {
  AddCompanyStore,
    CommonStore,
  BusinessLicenseImgStore,
  CardBackStore,
  CardFrontStore,
  OpeningPermitImgStore,
  OperatorCardFrontStore,
  OperatorCardBackStore,
} from "../../store";
import {
  PlusOutlined,
  UploadOutlined,
  SafetyCertificateOutlined,
  SyncOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import UploadImgStore from "../../store/modules/choose_compane/uploadRealNameImg_store";
import { UploadChangeParam } from "antd/lib/upload/interface";
import dayjs from "dayjs";

function UpdateOrAdd(props:any) {
  const formAccount = Form.useFormInstance();
  const formEnterprise = Form.useFormInstance();
  const formAdmission = Form.useFormInstance();
  const formOperator = Form.useFormInstance();
  const ref = useRef<FormInstance<any>>();
  const ref1 = useRef<FormInstance<any>>();
  const refLast = useRef<FormInstance<any>>();
  const [value, setValue] = useState<string>();

  useEffect(() => {
    AddCompanyStore.get_manager_code();
    AddCompanyStore.getSceneList();
    //获取其他的场景信息
    AddCompanyStore.toGetOtherScenes()
  }, []);
  const getAccountInformationFormData = (changeValue: any, allValues: any) => {
    AddCompanyStore.setAccountInformationFormData({
      ...allValues,
      ...changeValue,
    });
  };
  const onChange = (newValue: string) => {
    let arr=AddCompanyStore.oTherScenes.filter((item:any)=>AddCompanyStore.admissionMaterialsFormData.sceneIds.includes(Number(item.label)))
    arr.forEach((item:any)=>{
      if (!AddCompanyStore.admissionMaterialsFormData.otherContents ||!AddCompanyStore.admissionMaterialsFormData.otherContents.hasOwnProperty(item.label)){
        AddCompanyStore.admissionMaterialsFormData.otherContents[item.label as any]=null
        ref1.current?.setFieldValue(["otherContents", item.label], null);
        console.log(JSON.parse(JSON.stringify(AddCompanyStore.admissionMaterialsFormData.otherContents)))
      }
    })
    for (let key in AddCompanyStore.admissionMaterialsFormData.otherContents){
      if (!AddCompanyStore.admissionMaterialsFormData.sceneIds.includes(Number(key))){
        delete AddCompanyStore.admissionMaterialsFormData.otherContents[key]
        console.log(JSON.parse(JSON.stringify(AddCompanyStore.admissionMaterialsFormData.otherContents)))
      }
    }
    AddCompanyStore.admissionMaterialsFormData.otherContents={...AddCompanyStore.admissionMaterialsFormData.otherContents}
    setValue(newValue);

  };
  const getEnterpriseRealNameFormData = (changeValue: any, allValues: any) => {
    changeValue.businessLicenseImage = AddCompanyStore.enterpriseRealNameFormData.businessLicenseImage;
    changeValue.bankPermitImage = AddCompanyStore.enterpriseRealNameFormData.bankPermitImage;
    changeValue.legalPersonIdFront = AddCompanyStore.enterpriseRealNameFormData.legalPersonIdFront;
    changeValue.legalPersonIdBack = AddCompanyStore.enterpriseRealNameFormData.legalPersonIdBack;
    AddCompanyStore.setEnterpriseRealNameFormData({
      ...allValues,
      ...changeValue,
    });
  };
  const getAdmissionMaterialsFormData = (changeValue: any, allValues: any) => {
    if (allValues.otherContents&& changeValue.otherContents){
      changeValue.otherContents={...allValues.otherContents}
    }
    AddCompanyStore.setAdmissionMaterialsFormData({
      ...allValues,
      ...changeValue,
    });
  };
  const getOperatorFormData = (changeValue: any, allValues: any) => {
    changeValue.agentName = changeValue.agentName
      ? changeValue.agentName
      : AddCompanyStore.operatorFormData.agentName;
    changeValue.agentIdNumber = changeValue.agentIdNumber
      ? changeValue.agentIdNumber
      : AddCompanyStore.operatorFormData.agentIdNumber;
    changeValue.agentIdFront = changeValue.agentIdFront
      ? changeValue.agentIdFront
      : AddCompanyStore.operatorFormData.agentIdFront;
    changeValue.agentIdBack = changeValue.agentIdBack
      ? changeValue.agentIdBack
      : AddCompanyStore.operatorFormData.agentIdBack;
    changeValue.phoneVerificationSuccessCode =
      AddCompanyStore.operatorFormData.phoneVerificationSuccessCode;

    if (JSON.stringify(changeValue.agentType)) {
      OperatorCardBackStore.reset();
      OperatorCardFrontStore.reset();
      refLast.current?.setFieldsValue({
        agentType: changeValue.agentType,
        agentPhoneNumber: null,
        phoneVerificationCode: null,
        agentName: null,
        agentIdNumber: null,
        agentIdFront: null,
        agentIdBack: null,
      });
      AddCompanyStore.setOperatorFormData({ agentType: changeValue.agentType });
    } else {
      AddCompanyStore.setOperatorFormData({ ...allValues, ...changeValue });
    }
  };
  const toStep = async (value: any, current: number,flag:string) => {
    if (flag==='enterpriseRealName') {
      AddCompanyStore.setBusinessExpireDate(AddCompanyStore.enterpriseRealNameFormData.businessExpireDateFlag)
      AddCompanyStore.toCheckCustomer(AddCompanyStore.enterpriseRealNameFormData.registeredCapital, dayjs(AddCompanyStore.enterpriseRealNameFormData.establishmentDate).format("YYYY-MM-DD"));
    } else if (flag==='accountInformation') {
      AddCompanyStore.toCheckAM(AddCompanyStore.accountInformationFormData.customerManagerCode);
    }else if (flag==='admissionMaterials') {
        // AddCompanyStore.setNewAdmissionMaterialsFormData();
      AddCompanyStore.setStep(AddCompanyStore.currentStep + 1);
    } else if (flag==='operator') {
      AddCompanyStore.setNewAdmissionMaterialsFormData();
      if (props.process==='新建'){
        await AddCompanyStore.customerAdd();
      }else if (props.process==='企业认证' && !CommonStore.homePageDataList.authStatus){
        //老用户认证
        await AddCompanyStore.realNameAdd();
      }else if (props.process==='企业认证' && CommonStore.homePageDataList.authStatus=== 'FAILED'){
        //新用户认证失败再次认证
        await AddCompanyStore.newCustomersrealNameAdd();
      }else if (props.process==='账户信息变更'){
        await AddCompanyStore.accountUpdate();
      }else if (props.process==='企业认证变更'){
        await AddCompanyStore.realNameUpdate();
      }else if (props.process==='新增账户'){
        await AddCompanyStore.accountAdd();
      }

      if (AddCompanyStore.customerAddResult) {
        closeModal();
      }
    }
  };
  const comeBack = (current: number,flag:string) => {
    if (flag === 'enterpriseRealName' && AddCompanyStore.currentStep===0) {
      AddCompanyStore.addCompanyModal.close();
    } else
      if (flag === 'operator') {
      AddCompanyStore.callBackLast();
      OperatorCardBackStore.reset();
      OperatorCardFrontStore.reset();
      AddCompanyStore.setStep(AddCompanyStore.currentStep - 1);
    } else {
      AddCompanyStore.setStep(AddCompanyStore.currentStep - 1);
    }
  };
  function beforeUpload(file: any) {
    return false;
  }

  type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const handleUploadFileChange = (
    { file, fileList: newFileList }: UploadChangeParam,
    store: UploadImgStore,
    name:string
  ) => {
    console.log(newFileList, file)
    if (newFileList && newFileList.length > 0) {
      const isJpgOrPng =
        newFileList[0].type === "image/jpeg" ||
        newFileList[0].type === "image/png";
      if (!isJpgOrPng) {
        message.error("请上传图片格式文件!");
      } else if (!((newFileList as any)[0].size / 1024 / 1024 < 10)) {
        message.error("图片必须小于10MB!");
      } else {
        if (name==='legalPersonIdFront'||name==='legalPersonIdBack'||name==='businessLicenseImage'||name==='bankPermitImage'){
          getEnterpriseRealNameFormData({name:file},AddCompanyStore.enterpriseRealNameFormData)
          ref.current?.setFieldValue(name, {name:file});
        }else if (name==='agentIdFront'||name==='agentIdBack'){
          getOperatorFormData({name:file},AddCompanyStore.operatorFormData)
          refLast.current?.setFieldValue(name, {name:file});
        }
        store.setFileList(newFileList, file);
      }
    } else {
      store.setFileList(newFileList);
    }
  };
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };
  const getBase64 = (file: FileType): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
  const onFinishFailed: FormProps<any>["onFinishFailed"] = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const changePdfFile = ({ file, fileList: newFileList }: UploadChangeParam, name: string) => {
    AddCompanyStore.setpdfList(AddCompanyStore[name as keyof typeof AddCompanyStore].filter((f: any) => f.uid !== file.uid), name);
  };
  const pdfBeforeUpload = (file: any, name: string) => {
    if (
      file.type !== "application/pdf" &&
      file.type !== "image/jpeg" &&
      file.type !== "image/png" &&
      file.type !== "image/jpg" &&
      file.type !== "application/vnd.ms-excel" &&
      file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      message.error("请上传PDF文件、图片或excel文件");
      return Upload.LIST_IGNORE;
    } else {
      AddCompanyStore.temporaryUpload(file, name);
    }
    return false;
  };
  const handleRemove = (
    { file, fileList: newFileList }: UploadChangeParam,
    store: UploadImgStore,
    name: string
  ) => {
    ref.current?.setFieldValue(name, null);
  };

  const closeModal = () => {
    CardFrontStore.reset();
    CardBackStore.reset();
    BusinessLicenseImgStore.reset();
    OpeningPermitImgStore.reset();
    OperatorCardBackStore.reset();
    OperatorCardFrontStore.reset();
    AddCompanyStore.addCompanyModal.close()
  };
  const stepsItem:Array<any>=[
    { title: "账户信息填写", process:['新建','账户信息变更','企业认证','新增账户']},
    { title: "企业实名认证" ,process:['新建','企业认证变更','企业认证']},
    { title: "准入材料上传",process:['新建','企业认证','企业认证变更'] },
    { title: "经办人身份认证",process:['新建','企业认证','账户信息变更','企业认证变更','新增账户']},
  ]
  const disabledDate = (current:any) => {
    // 禁止选择当前日期之前的日期（包括当天）
    return current && current < dayjs().startOf('day');
  };

  return (
    <Fragment>
      <Modal
        width={800}
        centered
        title={props.process}
        open={AddCompanyStore.addCompanyModal.isOpen}
        destroyOnClose={true}
        onCancel={() => closeModal()}
        footer={null}
        maskClosable={false}
      >
        <Steps
          className="StepSty"
          size={"small"}
          current={AddCompanyStore.currentStep}
          items={stepsItem.filter((item:any,index:number)=>item.process.includes(props.process))}
        />
        {(AddCompanyStore.currentStep === 0 && props.process!=='企业认证变更') && (
          <Form
            form={formAccount}
            labelCol={{ span: 5 }}
            labelWrap
            initialValues={AddCompanyStore.accountInformationFormData}
            wrapperCol={{ flex: 1 }}
            onFinish={(e) => toStep(e, 0,'accountInformation')}
            onFinishFailed={onFinishFailed}
            onValuesChange={getAccountInformationFormData}
          >
            <Row style={{ maxHeight: "calc(70vh)", overflow: "auto" }}>
              <Col span={20} offset={1}>
                <Form.Item
                  label="企业账户名称"
                  name="businessAccountName"
                  rules={[{ required: true, message: "请输入企业账户名称，地区名+任意名，例：上海联华" }]}
                >
                  <Input placeholder="请输入" showCount maxLength={50} />
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="客户经理"
                  name="customerManagerCode"
                  rules={[{ required: true, message: "请输入客户经理编号" }]}
                >
                  <Input placeholder="请输入客户经理编号" showCount maxLength={50} />
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="签约公司"
                  name="signingCompany"
                  rules={[{ required: true, message: "请输入签约公司" }]}
                >
                  <Input placeholder="请输入签约公司，例：中国电信集团XX分公司" showCount maxLength={50} />
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="联系人姓名"
                  name="contactName"
                  rules={[{ required: true, message: "请输入联系人姓名" }]}
                >
                  <Input placeholder="请输入联系人姓名" showCount maxLength={50} />
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="联系人电话"
                  name="contactPhoneNumber"
                  rules={[{ required: true, message: "请输入联系人电话" }]}
                >
                  <Input placeholder="请输入联系人电话" showCount maxLength={11} minLength={11} />
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="联系人邮箱"
                  name="contactEmail"
                  rules={[{ required: true, message: "请输入联系人邮箱" }]}
                >
                  <Input placeholder="请输入联系人邮箱" showCount maxLength={50} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      htmlType="reset"
                      onClick={() => AddCompanyStore.addCompanyModal.close()}
                    >
                      取消
                    </Button>
                    <Button type="primary" htmlType="submit">
                      下一步
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
        {((AddCompanyStore.currentStep === 1 && props.process==='新建')||(AddCompanyStore.currentStep === 1 && props.process==='企业认证')||(AddCompanyStore.currentStep === 0 && props.process==='企业认证变更')) && (
          <Form
            form={formEnterprise}
            labelCol={{ span: 6 }}
            labelWrap
            ref={ref as any}
            initialValues={AddCompanyStore.enterpriseRealNameFormData}
            wrapperCol={{ flex: 1 }}
            onFinish={(e) => toStep(e, 1,'enterpriseRealName')}
            onFinishFailed={onFinishFailed}
            onValuesChange={getEnterpriseRealNameFormData}
          >
            <Row style={{ maxHeight: "calc(70vh)", overflow: "auto" }}>
              <Col span={20} offset={1}>
                <Form.Item
                  label="统一社会信用代码"
                  name="customerCreditCode"
                  rules={[
                    { required: true, message: "请输入统一社会信用代码" },
                  ]}
                >
                  <Input placeholder="请输入统一社会信用代码" disabled={props.process!=='新建' &&CommonStore.homePageDataList.authStatus=='APPROVED'}></Input>
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="企业名称"
                  name="customerName"
                  rules={[{ required: true, message: "请输入企业名称" }]}
                >
                  <Input placeholder="请输入企业名称"></Input>
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="注册资金（万）"
                  name="registeredCapital"
                  rules={[{ required: true, message: "请输入注册资金(万)" }]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    placeholder="请输入注册资金，例：100"
                  />
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="成立日期"
                  name="establishmentDate"
                  rules={[{ required: true, message: "请选择成立日期" }]}
                >
                  <DatePicker placeholder="请选择成立日期" />
                </Form.Item>
              </Col>
              <Col span={10} offset={1}>
                <Form.Item
                    label="营业有效期"
                    name="businessExpireDateFlag"
                    labelCol={{ span: 12 }}
                    rules={[{ required: true, message: "请选择营业有效期" }]}
                >
                  <Radio.Group
                      options={[
                        { value: '1', label: '长期' },
                        { value: '2', label: '短期' },
                      ]}
                  />
                </Form.Item>
              </Col>
              <Col span={10}>
                {AddCompanyStore.enterpriseRealNameFormData.businessExpireDateFlag==='2' &&<Form.Item
                    name="businessExpire"
                    rules={[{ required: true, message: "请选择营业有效期" }]}
                >
                  <DatePicker placeholder="请选择营业有效期" disabledDate={disabledDate}/>
                </Form.Item>}
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="法人姓名"
                  name="legalPersonName"
                  rules={[{ required: true, message: "请输入法人姓名" }]}
                >
                  <Input placeholder="请输入法人姓名"></Input>
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="法人身份证号码"
                  name="legalPersonIdNumber"
                  rules={[
                    {
                      required: true,
                      message: "请输入正确的法人身份证",
                      pattern: new RegExp(
                        /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)$/,
                        "g"
                      ),
                    },
                  ]}
                >
                  <Input placeholder="请输入"></Input>
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                    label="开户银行"
                    name="bankAccountName"
                    rules={[{ required: true, message: "请输入开户银行" }]}
                >
                  <Input placeholder="请输入开户银行"></Input>
                </Form.Item>
              </Col>
              <Col span={20} offset={1}>
                <Form.Item
                  label="开户银行账号"
                  name="bankAccountNumber"
                  rules={[{ required: true, message: "请输入开户银行账号" }]}
                >
                  <Input placeholder="请输入开户银行账号"></Input>
                </Form.Item>
              </Col>
              <Col span={8} offset={6}>
                <Form.Item
                  label="法人身份证正面"
                  labelCol={{ span: 24 }}
                  name="legalPersonIdFront"
                  rules={[{ required: true, message: "请上传" }]}
                >
                  <div>
                    <Upload
                      listType="picture-card"
                      fileList={CardFrontStore.fileList}
                      onPreview={handlePreview}
                      onChange={(e: any) => handleUploadFileChange(e, CardFrontStore,"legalPersonIdFront")}
                      beforeUpload={beforeUpload}
                      onRemove={(e: any) =>
                        handleRemove(e, CardFrontStore, "legalPersonIdFront")
                      }
                    >
                      {CardFrontStore.fileList.length >= 1
                        ? null
                        : uploadButton}
                    </Upload>
                  </div>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="法人身份证反面"
                  labelCol={{ span: 24 }}
                  name="legalPersonIdBack"
                  rules={[{ required: true, message: "请上传" }]}
                >
                  <div>
                    <Upload
                      action={""}
                      listType="picture-card"
                      fileList={CardBackStore.fileList}
                      onPreview={handlePreview}
                      onChange={(e) => handleUploadFileChange(e, CardBackStore,"legalPersonIdBack")}
                      beforeUpload={beforeUpload}
                      onRemove={(e: any) =>
                        handleRemove(e, CardBackStore, "legalPersonIdBack")
                      }
                    >
                      {CardBackStore.fileList.length >= 1 ? null : uploadButton}
                    </Upload>
                  </div>
                </Form.Item>
              </Col>
              <Col span={8} offset={6}>
                <Form.Item
                  label="营业执照图片"
                  labelCol={{ span: 24 }}
                  name="businessLicenseImage"
                  rules={[{ required: true, message: "请上传" }]}
                >
                  <div>
                    <Upload
                      action={""}
                      listType="picture-card"
                      fileList={BusinessLicenseImgStore.fileList}
                      onPreview={handlePreview}
                      onChange={(e) =>
                        handleUploadFileChange(e, BusinessLicenseImgStore,"businessLicenseImage")
                      }
                      beforeUpload={beforeUpload}
                      onRemove={(e: any) =>
                        handleRemove(
                          e,
                          BusinessLicenseImgStore,
                          "businessLicenseImage"
                        )
                      }
                    >
                      {BusinessLicenseImgStore.fileList.length >= 1
                        ? null
                        : uploadButton}
                    </Upload>
                    {previewImage && (
                      <Image
                        wrapperStyle={{ display: "none" }}
                        preview={{
                          visible: previewOpen,
                          onVisibleChange: (visible) => setPreviewOpen(visible),
                          afterOpenChange: (visible) =>
                            !visible && setPreviewImage(""),
                        }}
                        src={previewImage}
                      />
                    )}
                  </div>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="开户许可证图片"
                  labelCol={{ span: 24 }}
                  name="bankPermitImage"
                  rules={[{ required: true, message: "请上传" }]}
                >
                  <div>
                    <Upload
                      action={""}
                      listType="picture-card"
                      fileList={OpeningPermitImgStore.fileList}
                      onPreview={handlePreview}
                      onChange={(e) =>
                        handleUploadFileChange(e, OpeningPermitImgStore,"bankPermitImage")
                      }
                      beforeUpload={beforeUpload}
                      onRemove={(e: any) =>
                        handleRemove(
                          e,
                          OpeningPermitImgStore,
                          "bankPermitImage"
                        )
                      }
                    >
                      {OpeningPermitImgStore.fileList.length >= 1
                        ? null
                        : uploadButton}
                    </Upload>
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button htmlType="reset" onClick={() => comeBack(1,'enterpriseRealName')}>
                      {AddCompanyStore.currentStep === 0?'关闭':'返回'}
                    </Button>
                    <Button type="primary" htmlType="submit">
                      下一步
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
        {((AddCompanyStore.currentStep === 2 && props.process==='新建')||(AddCompanyStore.currentStep === 2 && props.process==='企业认证')||(AddCompanyStore.currentStep === 1 && props.process==='企业认证变更')) && (
          <Form
            form={formAdmission}
            labelCol={{ span: 12 }}
            labelWrap
            ref={ref1 as any}
            initialValues={AddCompanyStore.admissionMaterialsFormData}
            onFinish={(e) => toStep(e, 2,'admissionMaterials')}
            onFinishFailed={onFinishFailed}
            onValuesChange={getAdmissionMaterialsFormData}
          >
            <Row style={{ maxHeight: "calc(70vh)", overflow: "auto" }}>
              <Col span={11} offset={2}>
                <Form.Item
                  label="工作号业务开通承诺函"
                  name="businessCommitmentLetter"
                  valuePropName="fileList"
                  rules={[{ required: true, message: "请上传" }]}
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload
                    fileList={AddCompanyStore.businessCommitmentLetter}
                    onPreview={handlePreview}
                    onChange={(e) =>
                      changePdfFile(e, "businessCommitmentLetter")
                    }
                    beforeUpload={(e) =>
                      pdfBeforeUpload(e, "businessCommitmentLetter")
                    }
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={11}>
                <Form.Item
                  label="网络及信息安全承诺书"
                  name="networkSecurityCommitment"
                  rules={[{ required: true, message: "请上传" }]}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload
                    fileList={AddCompanyStore.networkSecurityCommitment}
                    onPreview={handlePreview}
                    onChange={(e) =>
                      changePdfFile(e, "networkSecurityCommitment")
                    }
                    beforeUpload={(e) =>
                      pdfBeforeUpload(e, "networkSecurityCommitment")
                    }
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={11} offset={2}>
                <Form.Item
                  label="客户责任授权书"
                  name="customerResponsibilityAuthorization"
                  rules={[{ required: true, message: "请上传" }]}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload
                    fileList={
                      AddCompanyStore.customerResponsibilityAuthorization
                    }
                    onPreview={handlePreview}
                    onChange={(e) =>
                      changePdfFile(e, "customerResponsibilityAuthorization")
                    }
                    beforeUpload={(e) =>
                      pdfBeforeUpload(e, "customerResponsibilityAuthorization")
                    }
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={11}>
                <Form.Item
                  label="规范使用业务承诺书"
                  name="businessUsageCommitment"
                  rules={[{ required: true, message: "请上传" }]}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload
                    fileList={AddCompanyStore.businessUsageCommitment}
                    onPreview={handlePreview}
                    onChange={(e) =>
                      changePdfFile(e, "businessUsageCommitment")
                    }
                    beforeUpload={(e) =>
                      pdfBeforeUpload(e, "businessUsageCommitment")
                    }
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={11} offset={2}>
                <Form.Item
                  label="工作号业务应用说明"
                  name="businessApplicationInstructions"
                  rules={[{ required: true, message: "请上传" }]}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload
                    fileList={AddCompanyStore.businessApplicationInstructions}
                    onPreview={handlePreview}
                    onChange={(e) =>
                      changePdfFile(e, "businessApplicationInstructions")
                    }
                    beforeUpload={(e) =>
                      pdfBeforeUpload(e, "businessApplicationInstructions")
                    }
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={11} >
                <Form.Item
                  label="话术模板"
                  name="speechTemplate"
                  rules={[{ required: true, message: "请上传" }]}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload
                    fileList={AddCompanyStore.speechTemplate}
                    onPreview={handlePreview}
                    onChange={(e) => changePdfFile(e, "speechTemplate")}
                    beforeUpload={(e) => pdfBeforeUpload(e, "speechTemplate")}
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={11} offset={2}>
                <Form.Item
                  label="社保证明"
                  name="socialSecurityProof"
                  rules={[{ required: true, message: "请上传" }]}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload
                    fileList={AddCompanyStore.socialSecurityProof}
                    onPreview={handlePreview}
                    onChange={(e) => changePdfFile(e, "socialSecurityProof")}
                    beforeUpload={(e) =>
                      pdfBeforeUpload(e, "socialSecurityProof")
                    }
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={11}>
                <Form.Item
                  label="合同链"
                  name="contractChain"
                  rules={[{ required: true, message: "请上传" }]}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload
                    fileList={AddCompanyStore.contractChain}
                    onPreview={handlePreview}
                    onChange={(e) => changePdfFile(e, "contractChain")}
                    beforeUpload={(e) => pdfBeforeUpload(e, "contractChain")}
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={11} offset={2}>
                <Form.Item
                    label="资质证明"
                    name="qualificationProof"
                    // rules={[{ required: true, message: "请上传" }]}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e && e.fileList;
                    }}
                >
                  <Upload
                      fileList={AddCompanyStore.qualificationProof}
                      onPreview={handlePreview}
                      onChange={(e) => changePdfFile(e, "qualificationProof")}
                      beforeUpload={(e) =>
                          pdfBeforeUpload(e, "qualificationProof")
                      }
                  >
                    <Button icon={<UploadOutlined />}>上传附件</Button>
                  </Upload>
                </Form.Item>
              </Col>
                <Col span={11} >
                    <Form.Item
                        label="场景使用说明"
                        name="scene"
                        rules={[{ required: true, message: "请上传" }]}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                            if (Array.isArray(e)) {
                                return e;
                            }
                            return e && e.fileList;
                        }}
                    >
                        <Upload
                            fileList={AddCompanyStore.scene}
                            onPreview={handlePreview}
                            onChange={(e) => changePdfFile(e, "scene")}
                            beforeUpload={(e) => pdfBeforeUpload(e, "scene")}
                        >
                            <Button icon={<UploadOutlined />}>上传附件</Button>
                        </Upload>
                    </Form.Item>
                </Col>
                <Col span={11} offset={2}>
                    <Form.Item
                        label="使用场景"
                        name="sceneIds"
                        rules={[{ required: true, message: "请选择使用场景" }]}
                    >
                        <TreeSelect
                            showSearch
                            style={{ width: "100%" }}
                            value={value}
                            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                            placeholder="请选择报备场景"
                            allowClear
                            multiple
                            treeDefaultExpandAll
                            fieldNames={{ value: "sceneId" }}
                            onChange={onChange}
                            treeData={AddCompanyStore.accountSceneList}
                            maxTagCount="responsive"
                        />
                    </Form.Item>
                </Col>
                {AddCompanyStore.admissionMaterialsFormData.sceneIds &&AddCompanyStore.oTherScenes.filter((item:any)=>AddCompanyStore.admissionMaterialsFormData.sceneIds.includes(Number(item.label))).map((item:any,index:number)=>
                  (<Col span={11} key={index} offset={(index % 2 === 0)?0:2}>
                    <Form.Item
                        label={item.value}
                        name={['otherContents',item.label]}
                        rules={[{ required: true, message: "请输入其他内容" }]}
                    >
                      <Input placeholder='请输入其他内容'/>
                    </Form.Item>
                 </Col>)
                )}

            </Row>
            <Row>
              <Col span={24}>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button htmlType="reset" onClick={() => comeBack(2,'admissionMaterials')}>
                      返回
                    </Button>
                    <Button type="primary" htmlType="submit">
                      下一步
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
        {((AddCompanyStore.currentStep === 3 && props.process==='新建')||(AddCompanyStore.currentStep === 3 && props.process==='企业认证')||(AddCompanyStore.currentStep === 1 && props.process==='账户信息变更')||(AddCompanyStore.currentStep === 1 && props.process==='新增账户')||(AddCompanyStore.currentStep === 2 && props.process==='企业认证变更')) && (
          <Form
            ref={refLast as any}
            form={formOperator}
            labelCol={{ span: 5 }}
            labelWrap
            initialValues={AddCompanyStore.operatorFormData}
            onFinish={(e) => toStep(e, 3,'operator')}
            onFinishFailed={onFinishFailed}
            onValuesChange={getOperatorFormData}
          >
            <Row style={{ maxHeight: "calc(70vh)", overflow: "auto" }}>
              <Col span={19} offset={2}>
                <Form.Item
                  label="经办人身份"
                  name="agentType"
                  rules={[{ required: true, message: "请选择经办人身份" }]}
                >
                  <Radio.Group
                    disabled={AddCompanyStore.urlLink ? true : false}
                    onChange={(e) => AddCompanyStore.onChangeRadio(e)}
                  >
                    <Radio value={0}>法定代表人</Radio>
                    <Radio value={1}>企业员工</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={19} offset={2}>
                <div className="fontTips">
                  在新增企业账户前,请先完成经办人手机号码的验证
                </div>
              </Col>
              <Col span={19} offset={2}>
                <Form.Item
                  label="经办人手机号码"
                  name="agentPhoneNumber"
                  labelCol={{ span: 8 }}
                  style={{ width: "62%", display: "inline-block" }}
                  rules={[{ required: true, message: "请输入经办人手机号码" }]}
                >
                  <Input
                    placeholder="请输入"
                    showCount
                    maxLength={11} minLength={11}
                    disabled={AddCompanyStore.operatorFormData.phoneVerificationSuccessCode}
                  />
                </Form.Item>
                {!AddCompanyStore.operatorFormData
                  .phoneVerificationSuccessCode && (
                  <Button
                    type="link"
                    style={{ marginLeft: "10px" }}
                    onClick={() => AddCompanyStore.toGetCode()}
                    disabled={
                      AddCompanyStore.codeTime > 0 &&
                      AddCompanyStore.codeTime < 60
                    }
                  >
                    {AddCompanyStore.codeTime > 0 &&
                    AddCompanyStore.codeTime < 60
                      ? `${AddCompanyStore.codeTime}后重新获取`
                      : "获取验证码"}
                  </Button>
                )}
                {AddCompanyStore.operatorFormData
                  .phoneVerificationSuccessCode && (
                  <SafetyCertificateOutlined
                    style={{
                      marginLeft: "10px",
                      color: "green",
                      marginTop: "12px",
                    }}
                  />
                )}
              </Col>
              {!AddCompanyStore.operatorFormData
                .phoneVerificationSuccessCode && (
                <Col span={19} offset={2}>
                  <Form.Item
                    label="手机验证码"
                    labelCol={{ span: 8 }}
                    style={{ width: "62%", display: "inline-block" }}
                    name="phoneVerificationCode"
                    rules={[{ required: true, message: "请输入手机验证码" }]}
                  >
                    <Input placeholder="请输入" showCount maxLength={10} />
                  </Form.Item>
                  <Button
                    type="primary"
                    style={{ marginLeft: "10px" }}
                    disabled={!AddCompanyStore.getCode}
                    onClick={() => AddCompanyStore.toCheckPhone()}
                  >
                    手机号码验证
                  </Button>
                </Col>
              )}
              {AddCompanyStore.operatorFormData.agentType == 1 && (
                <Col span={19} offset={2}>
                  <Form.Item
                    label="经办人姓名"
                    name="agentName"
                    rules={[{ required: true, message: "请输入经办人姓名" }]}
                  >
                    <Input
                      disabled={AddCompanyStore.urlLink ? true : false}
                      placeholder="请输入"
                      showCount
                      maxLength={10}
                    />
                  </Form.Item>
                </Col>
              )}
              {AddCompanyStore.operatorFormData.agentType == 1 && (
                <Col span={19} offset={2}>
                  <Form.Item
                    label="经办人身份证号码"
                    name="agentIdNumber"
                    rules={[
                      {
                        required: true,
                        message: "请输入正确的经办人身份证号码",
                        pattern: new RegExp(
                          /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)$/,
                          "g"
                        ),
                      },
                    ]}
                  >
                    <Input
                      disabled={AddCompanyStore.urlLink ? true : false}
                      placeholder="请输入"
                      showCount
                      maxLength={20}
                    />
                  </Form.Item>
                </Col>
              )}
              {AddCompanyStore.operatorFormData.agentType == 1 && (
                <Col span={8} offset={6}>
                  <Form.Item
                    label="经办人身份证正面"
                    labelCol={{ span: 24 }}
                    name="agentIdFront"
                    rules={[{ required: true, message: "请上传" }]}
                  >
                    <div>
                      <Upload
                        listType="picture-card"
                        disabled={AddCompanyStore.urlLink ? true : false}
                        fileList={OperatorCardFrontStore.fileList}
                        onPreview={handlePreview}
                        onChange={(e: any) =>
                          handleUploadFileChange(e, OperatorCardFrontStore,"agentIdFront")
                        }
                        beforeUpload={beforeUpload}
                        onRemove={(e: any) =>
                          handleRemove(e, CardFrontStore, "agentIdFront")
                        }
                      >
                        {OperatorCardFrontStore.fileList.length >= 1
                          ? null
                          : uploadButton}
                      </Upload>
                    </div>
                  </Form.Item>
                </Col>
              )}
              {AddCompanyStore.operatorFormData.agentType == 1 && (
                <Col span={8}>
                  <Form.Item
                    label="经办人身份证反面"
                    labelCol={{ span: 24 }}
                    name="agentIdBack"
                    rules={[{ required: true, message: "请上传" }]}
                  >
                    <div>
                      <Upload
                        disabled={AddCompanyStore.urlLink ? true : false}
                        listType="picture-card"
                        fileList={OperatorCardBackStore.fileList}
                        onPreview={handlePreview}
                        onChange={(e) =>
                          handleUploadFileChange(e, OperatorCardBackStore,"agentIdBack")
                        }
                        beforeUpload={beforeUpload}
                        onRemove={(e: any) =>
                          handleRemove(e, CardFrontStore, "agentIdBack")
                        }
                      >
                        {OperatorCardBackStore.fileList.length >= 1
                          ? null
                          : uploadButton}
                      </Upload>
                    </div>
                  </Form.Item>
                </Col>
              )}
              <Col span={19} offset={2}>
                <div className="fontTips">
                  在新增企业账户前,请先完成经办人身份验证
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ marginRight: "50px", height: "120px" }}>
                    <Button
                        disabled={AddCompanyStore.wxCheckURLBtn}
                      onClick={() =>
                        AddCompanyStore.wxCheckURL(
                          AddCompanyStore.urlLink
                            ? "取消身份认证"
                            : "经办人身份认证"
                        )
                      }
                    >
                      {AddCompanyStore.urlLink
                        ? "取消身份认证"
                        : "经办人身份认证"}
                    </Button>
                  </div>
                  <div style={{ display: "flex", alignItems: "flex-end" }}>
                    {AddCompanyStore.urlLink && (
                      <QRCode size={120} value={AddCompanyStore.urlLink} />
                    )}
                    {AddCompanyStore.urlLink &&
                      !AddCompanyStore.wxCheckResult && (
                        <div>
                          <SyncOutlined spin style={{ margin: "5px" }} />{" "}
                          <span>身份认证中…</span>
                        </div>
                      )}
                    {AddCompanyStore.urlLink &&
                      AddCompanyStore.wxCheckResult === "2" && (
                        <div>
                          <CloseCircleOutlined style={{ margin: "5px" }} />{" "}
                          <span>身份认证失败</span>
                        </div>
                      )}
                    {AddCompanyStore.urlLink &&
                      AddCompanyStore.wxCheckResult === "3" && (
                        <div>
                          <CheckCircleOutlined style={{ margin: "5px" }} />{" "}
                          <span>身份认证成功</span>
                        </div>
                      )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button htmlType="reset" onClick={() => comeBack(3,'operator')}>
                      返回
                    </Button>
                    <Button
                      disabled={
                        AddCompanyStore.wxCheckResult === "3" ? false : true
                      }
                      type="primary"
                      htmlType="submit"
                      loading={AddCompanyStore.buttonLoading}
                    >
                      提交
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
      </Modal>
    </Fragment>
  );
}

export default observer(UpdateOrAdd);
